import React from 'react';
import Layout from '../components/Layout';

const NotFound = () => {
    
    const center = {
        textAlign: 'center'
    }

    return ( 
        <Layout>
            <div style={center}>
                <h1>404</h1>
                <p>This is the 404 Page, which means this page does not exist. <a href="/">Click here to go back home.</a></p>
            </div>
        </Layout>
     );
}
 
export default NotFound;